// @ts-check
import { fetchJsonWithRetry } from "./FetchWithRetry";
import { GameList } from "./game_lists/GameListEntry";
import { redirectUrl } from "./Redirect";
import { initSentry } from "./Sentry";

/**
 * @typedef {Object} BuildConfiguration
 * @property {{
 *   staging: number,
 *   stage1: number,
 *   stage2: number,
 *   stage3: number,
 *   stage4: number
 * }} online
 * @property {{
 *   staging: number,
 *   stage1: number,
 *   stage2: number,
 *   stage3: number,
 *   stage4: number
 * }} onlineSelective
 * @property {{
 *   staging: string,
 *   production: string
 * }} jackpots
 */

console.log("index.js reached")
if (new URL(document.location.href).searchParams.get("addBreakpointAtRedirectsStart")) {
    new Function("debugger")();
}
initSentry();
console.log("Sentry started")

const redirectsConfigUrl = document.location.origin.includes("127.0.0.1") || document.location.origin.includes("localhost") ? document.location.origin + "/dist/redirects_configuration.json" : document.location.origin + "/redirects_configuration.json";

(async () => {
    /** @type {BuildConfiguration} */
    const buildsConfiguration = await fetchJsonWithRetry(redirectsConfigUrl);
    const url = new URL(document.location.href);
    const newUrl = redirectUrl(url, GameList, buildsConfiguration)
    document.location.replace(newUrl);
})();

